module.exports = "<script type=\"text/html\" id=\"survey-question-signaturepad\">\n    <div data-bind=\"css: question.koCss().root\">\n        <div>\n            <canvas tabindex='0'></canvas>\n        </div>\n        <div data-bind=\"css: question.koCss().controls\">\n            <button type='button' data-bind=\"css: question.koCss().clearButton, attr: { title: question.clearButtonCaption }\">✖</button>\n        </div>\n    </div>\n</script>";


//////////////////
// WEBPACK FOOTER
// ./src/knockout/templates/question-signaturepad.html
// module id = 99
// module chunks = 0